import { sharedEnvironment } from '@vinnova/environments';

const bedomningsPortalApiBaseURI = `${sharedEnvironment.utv.gatewayUrl}/bedomningsportal`;

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.utv.ansokanUrl,
  bpUrl: sharedEnvironment.utv.bpUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  bedomningsPortalApiUrl: bedomningsPortalApiBaseURI,
  etjansterCommonApiUrl: `${sharedEnvironment.utv.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/BP`,
  projektUrl: sharedEnvironment.utv.projektUrl,
  externalLinks: sharedEnvironment.utv.externalLinks,
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  chatbotApiUrl: bedomningsPortalApiBaseURI + '/chatbot',
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      bedomningsPortalApiBaseURI,
      sharedEnvironment.utv.azureAdB2C.clientId.bedomningsportalClientId,
      sharedEnvironment.utv.azureAdB2C.clientId.bedomningsportalApiClientId,
    ),
    authority: sharedEnvironment.utv.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.utv.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.utv.azureAdB2C.clientId.bedomningsportalApiClientId}/all`,
    tenant: sharedEnvironment.utv.azureAdB2C.tenant,
    policies: sharedEnvironment.utv.azureAdB2C.policies,
    clientId: sharedEnvironment.utv.azureAdB2C.clientId,
  },
};
